const WEB_VITALS_ENDPOINT_PATH = "/_web-vitals";
export {
  WEB_VITALS_ENDPOINT_PATH
};
